var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCondividi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1731 23.105C24.6038 23.105 23.2423 23.9465 22.4808 25.1913L16.3308 22.1137C16.5269 21.6181 16.6538 21.0763 16.6538 20.5C16.6538 19.9237 16.5385 19.3819 16.3308 18.8863L22.4808 15.8087C23.2423 17.0535 24.6038 17.895 26.1731 17.895C28.5615 17.895 30.5 15.9585 30.5 13.5725C30.5 11.1865 28.5615 9.25 26.1731 9.25C23.7846 9.25 21.8462 11.1865 21.8462 13.5725C21.8462 13.7684 21.8808 13.9644 21.9038 14.1603L15.3962 17.4109C15.3962 17.4109 15.3846 17.4224 15.3731 17.4339C14.5885 16.6501 13.5154 16.1775 12.3269 16.1775C9.93846 16.1775 8 18.114 8 20.5C8 22.886 9.93846 24.8225 12.3269 24.8225C13.5154 24.8225 14.6 24.3384 15.3731 23.5661C15.3731 23.5661 15.3846 23.5776 15.3962 23.5891L21.9038 26.8397C21.8808 27.0356 21.8462 27.2316 21.8462 27.4275C21.8462 29.8135 23.7846 31.75 26.1731 31.75C28.5615 31.75 30.5 29.8135 30.5 27.4275C30.5 25.0415 28.5615 23.105 26.1731 23.105ZM26.1731 11.002C27.6038 11.002 28.7692 12.1662 28.7692 13.5955C28.7692 15.0248 27.6038 16.189 26.1731 16.189C24.7423 16.189 23.5769 15.0248 23.5769 13.5955C23.5769 12.1662 24.7423 11.002 26.1731 11.002ZM12.3269 23.105C10.8962 23.105 9.73077 21.9408 9.73077 20.5115C9.73077 19.0822 10.8962 17.918 12.3269 17.918C13.7577 17.918 14.9231 19.0822 14.9231 20.5115C14.9231 21.9408 13.7577 23.105 12.3269 23.105ZM26.1731 30.021C24.7423 30.021 23.5769 28.8568 23.5769 27.4275C23.5769 25.9982 24.7423 24.834 26.1731 24.834C27.6038 24.834 28.7692 25.9982 28.7692 27.4275C28.7692 28.8568 27.6038 30.021 26.1731 30.021Z",
    fill: "#125F65"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondividi);
export default __webpack_public_path__ + "static/media/condividi.8fed8f50.svg";
export { ForwardRef as ReactComponent };